module.exports = __webpack_public_path__ + "img/background_green.aa923cda.svg";